<template>
  <div class="onboarding">
    <div class="onboarding-title">
      <h4>Welcome to <span>Verify Identity</span></h4>
      <p>Let's help verify the identity of your users</p>
    </div>
    <div class="onboarding-image">
      <img
        :src="getImage('products/verify-id.svg')"
        alt="VerifyIdentity"
        class="fadeIn"
      />
      <img
        :src="getImage('products/divider.svg')"
        alt="AuthX"
        class="divider fadeIn"
      />
      <img
        :src="getImage('products/verified.svg')"
        alt="Verified"
        class="verified fadeIn"
      />
    </div>
    <div class="onboarding-actions">
      <el-button
        v-if="!isOrganisationActive"
        type="primary"
        @click="verifyAccount"
        >Activate Organisation</el-button
      >
      <el-button
        type="primary"
        :plain="!isOrganisationActive"
        :disabled="!isOrganisationActive"
        @click="showProductOptIn = true"
        >Let's begin</el-button
      >
    </div>
    <product-opt-in
      :show.sync="showProductOptIn"
      :product="'verify-id'"
      @success="goToVerifyIdentity"
    />
  </div>
</template>

<script>
import ProductOptIn from "@/components/Products/ProductOptIn";
import {
  isOrganisationActive,
  isProductAccessible,
  userCan
} from "@/lib/utils";
import notification from "element-ui/packages/notification";

export default {
  name: "VerifyIdentityOnboarding",
  components: { ProductOptIn },
  data() {
    return {
      isOrganisationActive: isOrganisationActive(),
      showProductOptIn: false
    };
  },
  methods: {
    verifyAccount() {
      this.$router.push({ name: "organisation.index", hash: "#settings" });
    },
    goToVerifyIdentity() {
      this.$router.push({ name: "verify-identity.index" });
    }
  },
  beforeRouteEnter(to, from, next) {
    const allowAdmin = userCan("auth", "feature.saveorganisationfeature");
    const allowProductView = isProductAccessible("verify-id");

    let title = "";
    let message = "";

    if (!isOrganisationActive()) {
      if (userCan("auth", "organisation.update")) {
        next({ name: "organisation.index", hash: "#settings" });
        title = "Inactive Organisation";
        message = "You need to activate your organisation.";
      } else {
        next({ name: "home.index" });
        title = "Inactive Organisation";
        message = "Contact organisation admin.";
      }
    } else {
      if (!allowProductView && allowAdmin) {
        next();
      } else {
        next({ name: "verify-identity.index" });
      }
    }

    if (title) {
      notification({
        title,
        message,
        customClass: "error"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.onboarding {
  width: 100%;
  padding: 40px 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &-title {
    text-align: center;
  }

  &-image {
    width: 60%;
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0;
    border-radius: 10px;

    img {
      border-radius: 10px;
      width: 100%;
      box-shadow: 0 0 30px 0 rgb(82 63 105 / 7%);

      &:not(:last-child) {
        margin-right: 20px;
      }

      &.divider {
        border-radius: 1000px;
        height: 40px;
        -webkit-animation-delay: 0.5s;
        animation-delay: 0.5s;
      }

      &.verified {
        -webkit-animation-delay: 1s;
        animation-delay: 1s;
      }
    }
  }

  &-actions {
    display: flex;
  }
}
</style>
